import { AppData, Domain, Character, Connection } from '../data/types';

export const cloneSaveFormat = (save: AppData): AppData => ({ ...save, domains: cloneDomains(save.domains) });
export const cloneDomains = (domains: Domain[]): Domain[] => domains.map(cloneDomain);
export const cloneDomain = (domain: Domain): Domain => ({ ...domain, characters: cloneCharacters(domain.characters) });
export const cloneCharacters = (chars: Character[]): Character[] => chars.map(cloneCharacter);
export const cloneCharacter = (char: Character): Character => ({ ...char, connections: cloneConnections(char.connections) });
export const cloneConnections = (conns: Connection[]): Connection[] => conns.map(cloneConnection);
export const cloneConnection = (conn: Connection): Connection => ({ ...conn });
